import classnames from 'classnames';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import classes from './index.module.scss';

import { useEffect, type PropsWithChildren, type ReactNode } from 'react';
import { useSnapshotPageName } from '@/stores/pageName';

interface INotfoundProps extends PropsWithChildren {
  className?: string;
  callback?: ReactNode;
}

const Notfound = (props: INotfoundProps) => {
  const { className, callback } = props;
  const navigate = useNavigate();
  const { pageName, setPageName,prePageName, setPrePageName, getPageName } = useSnapshotPageName();

  useEffect(() => {
    gio('track', "OW_404pageView", {
      "parPageName_var" : `404页面`,
    });
    setPrePageName(getPageName());
    setPageName('404页面');
  }, [])

  return (
    <div className={classnames('Notfound', classes.wrap, className)}>
      <Result
        status="404"
        extra={
          callback !== undefined ? (
            callback
          ) : (
            <Button type="primary" onClick={() => {
              gio('track', "OW_404ButtonClick", {
                "parPageName_var" : `404页面`,
              });
              navigate('/home');
              }}>
              返回首页
            </Button>
          )
        }
      />
    </div>
  );
};

export default Notfound;
